import {formatNIS} from '@sollapay/utils';

import {cn} from '../../lib/utils';
import {Typography} from '../Typography';

import type {FC} from 'react';

export interface AmountDisplayProps {
  amount: string;
  variant: 'credit' | 'debit';
  size?: 'xs' | 'sm' | 'md';
  className?: string;
}

export const AmountDisplay: FC<AmountDisplayProps> = ({
  amount,
  variant,
  size = 'md',
  className
}) => {
  const isCredit = variant === 'credit';
  return (
    <span data-slot="amount-display" dir="ltr">
      <Typography
        size={size}
        weight="semibold"
        className={cn(isCredit ? 'text-fg-credit' : 'text-destructive', className)}
      >
        {isCredit ? '+' : '-'} {formatNIS(amount)}
      </Typography>
    </span>
  );
};
